module.exports = __webpack_public_path__ + "img/cc-visa.b6cf032d.svg";